"use client";

import { useEffect } from "react";
import { useGardenAtmosphere } from "./GardenAtmosphereProvider";
import { gardenPalette } from "@/lib/garden-atmosphere";
import GardenScene from "./GardenScene";

export default function GardenAtmosphere() {
  const { ready, sceneMinutes: minutes, season } = useGardenAtmosphere();
  const palette = gardenPalette(minutes, season);

  useEffect(() => {
    if (!ready) return;
    const root = document.documentElement;
    root.style.setProperty("--garden-accent", palette.accent);
    root.style.setProperty("--garden-glow", palette.glow);
    return () => {
      root.style.removeProperty("--garden-accent");
      root.style.removeProperty("--garden-glow");
    };
  }, [ready, palette.accent, palette.glow]);

  if (!ready) return null;
  return (
    <>
      <div
        aria-hidden="true"
        className="garden-ambient"
        style={{
          background: `radial-gradient(ellipse at 90% 5%, color-mix(in srgb, ${palette.horizon} 30%, transparent), transparent 55%), radial-gradient(ellipse at 4% 45%, ${palette.glow}35, transparent 50%)`,
        }}
      />
      <GardenScene />
    </>
  );
}
